
// const get_api = 'https://dddemo.net/php/2023/Royceindia-app/public/api/products';
// const post_api = 'https://dddemo.net/php/2023/Royceindia-app/public/api/products';

const get_api = 'https://apps.royceindia.com/Royceindia-app/public/api/products';
const post_api = 'https://apps.royceindia.com/Royceindia-app/public/api/products';

// const get_api = 'https://apps.dynamicdreamz.com/php/2023/Royceindia-app/public/api/products';
// const post_api = 'https://apps.dynamicdreamz.com/php/2023/Royceindia-app/public/api/products';
$(document).ready(function() {

  setTimeout(function() {
  // console.log(localStorage.getItem("Zipcode") != null );
    if(localStorage.getItem("Zipcode") != null){
      $("input.delivery_location_zip_mobile_input").val(localStorage.getItem("Zipcode"));
      $("#cart_delivery-location-search").click();
      if ($(window).width() <= 768) {
        // $('#check_zipcode_mobile').click();
      }
      else{
        $('#check_zipcode').click();
      }
    }
  },500);
    
  $("#check_zipcode").click(function (e){
    $('.but-note').addClass('hide');
     e.preventDefault();
          var zipcode = $("#delivery_location_zip").val(),
              productID = $("#product_product_id").val(),
              productvarientID = $("#product_variant_variant_id").val();
    $('.note.defualt_massage').hide();
    $('.msg-status').remove();
    if (zipcode.length == 0 ){
       $('.ProductForm__AddToCart').attr("disabled","disabled");
    }else if(zipcode.length <= 5){
       $('.ProductForm__AddToCart').attr("disabled","disabled");
    }else{
     checkProduct(productID,zipcode,productvarientID);
    }
  });

  $("#check_zipcode_mobile").click(function (e){
    $('.but-note').addClass('hide');
     e.preventDefault();
      var zipcode = $("#delivery_location_zip_mobile").val(),
      productID = $("#product_product_id_mobile").val(),
      productvarientID = $("#product_variant_variant_id_mobile").val();
    $('.note.defualt_massage').hide();
    $('.msg-status').remove();
    if (zipcode.length == 0 ){
       $('.ProductForm__AddToCart').attr("disabled","disabled");
    }else if(zipcode.length <= 5){
       $('.ProductForm__AddToCart').attr("disabled","disabled");
    }else{
     checkProduct(productID,zipcode,productvarientID);
    }
  });
  
  $(".add-to-cart-wrapper").click(function (e){
    $('.product-sticky-block .product-sticky-delivery, .but-note').removeClass('hide');
    if($('#delivery_location_zip_mobile').val() != null){
      $('#check_zipcode_mobile').click();
    }
  });

  $('#cart-checkbox-btn-overlay').click(function (e){
    console.log("click-checkout");
    console.log($('#date-picker-input').val() == '' && $('#cart_delivery_location_zip').val() == '' || $('#date-picker-input').val() == null && $('#cart_delivery_location_zip').val() == null );
    if($('#date-picker-input').val() == '' && $('#cart_delivery_location_zip').val() == '' || $('#date-picker-input').val() == null && $('#cart_delivery_location_zip').val() == null ){
       $('.cart-zip-massage-main').show();
      $('.msg-status').text('Please enter PIN code first to check if PIN code is servicable').show().css("color", "red");
    } else if ($('#date-picker-input').val() == ''){
      $('.cart-zip-massage-main').show();
      $('.msg-status').text('Please select date').show().css("color", "red");
    }    
  });

  $(document).on('click', 'body', function(event) {
  // console.log(event.target);
    if (!$(event.target).is('.product-sticky')){
      if (!$(event.target).is('.add-to-cart-wrapper')){
        if ($(event.target).parents('.product-sticky').length == 0 ){
          $('.product-sticky-block .product-sticky-delivery').addClass('hide');
        }
      }
    }
  });

  
  $(".product-delivery-form .delivery_location_zip_mobile_input").on('keyup', function(event) {
    $(".check_pdp_zip").removeClass("focus");
    var check_zip_length = $(this).val();
    console.log("check_zip_length",check_zip_length.length);
    $('#cart-max_dyas-date-input, #date-picker-input').val('');
    // console.log(check_zip_length);
    // $('#check_zipcode, #check_zipcode_mobile').text("Check");
    $('#check_zipcode, #check_zipcode_mobile, #cart_delivery-location-search').show();
    $('#check_zipcode_cleare_mobile, #check_zipcode_cleare, .cart-zip-massage-main, .change_cleare_zip ').hide();
    if (check_zip_length.length == 0 ){
      $('.product-delivery-form').removeClass('error').removeClass('success');
      $('.note.massage_wipwe').hide();
      $(".add-to-cart-wrapper").show();
      $('#cart-date-picker').empty();
      $('#cart-max_dyas-date-input, #date-picker-input').val('');
      $('#cart-checkbox-btn-overlay').show();
    }
    else if (check_zip_length.length <= 5) {
      $('.product-delivery-form').addClass('error');
      $('.note.massage_wipwe').text("Please Enter Six Digit ZIP Code").show();
      $(".add-to-cart-wrapper").show();
      $(".check_pdp_zip").css("pointer-events", "none");
      $('#cart-date-picker').empty();
      $('#cart-max_dyas-date-input, #date-picker-input').val('');
      $('#cart-checkbox-btn-overlay').show();
    }
    else if(check_zip_length.length == 6){
      var zipcode = $('#cart_delivery_location_zip').val();
      console.log("zipcode");
      console.log(zipcode);
      post_zipApp_cart(zipcode,cart_pro);
      $('.product-delivery-form').removeClass('error').removeClass('success');
      $('.note.massage_wipwe').text("").hide();
      $(".check_pdp_zip").css("pointer-events", "auto");
      $(".add-to-cart-wrapper").show(); 
    }
    else if(check_zip_length.length > 6){
      $('.cart-zip-massage-main').show();
      $('.cart-zip-massage-main .msg-status').text(`Please Enter Six Digit ZIP Code`).css("color", "red");
    }
    else {
      $('.product-delivery-form').removeClass('error').removeClass('success');
      $('.note.massage_wipwe').text("").hide();
      $(".check_pdp_zip").css("pointer-events", "auto");
      $(".add-to-cart-wrapper").show();
    }
  });

  $(".product-delivery-form .change_cleare_zip").on('click', function(event) {
    event.preventDefault();
    $('.product-delivery-form .delivery_location_zip_mobile_input').val(null);
    $('.product-delivery-form').removeClass('error').removeClass('success');
    $('#check_zipcode, #check_zipcode_mobile, #cart_delivery-location-search').show();
    $('#check_zipcode_cleare_mobile, #check_zipcode_cleare , .cart-zip-massage-main, .change_cleare_zip').hide();
  });
  
});

  var qty_check = 0;

  console.log(get_api,post_api)
  let checkProduct = (productID,zipcode,productvarientID) =>{
  console.log(productID,zipcode,productvarientID);
  // console.log(`${get_api}/${productID}/${zipcode}/${productvarientID}`);
    $.ajax({
      url: `${get_api}/${productID}/${zipcode}/${productvarientID}`,
      type: 'GET',
      success: function(response) {
        console.log(typeof response);
        if(typeof response === "string"){
          var response = JSON.parse(response); 
        }
        // var response = JSON.parse(response); 
        console.log("response:-" , response);
        localStorage.removeItem("Zipcode");
        localStorage.setItem("Zipcode", zipcode );
        if(response.success != true)
        {
          $(".product-delivary span.note.massage_wipwe").removeClass('hide').removeClass('success').addClass('error').empty();
          $(".product-delivery-form ").removeClass('success').addClass('error');
          $(".product-delivary span.note.massage_wipwe").append(response.message).show();
          //$(".btn.btn--full.add-to-cart-wrapper").show();
          // $(".btn.btn--full.add-to-cart-wrapper span").empty().append(response.label);
          $(".btn.btn--full.add-to-cart-wrapper").addClass('disable');
          //$('.btn.btn--full.add-to-cart').attr("disabled","disabled");
          //$('.product-block.product_quantity.small--hide').hide();
          //$('.product-block.product-buy-button.small--hide').addClass("hide-qty");
        }
        else{
          // console.log($(window).width());
          if ($(window).width() <= 768) {
            if(response.quantity < $('.js-qty__num_mob').val()){
              $('input.js-qty__num_mob').val(response.quantity);
              $("span.qty-note").empty().append(`You can not enter more than ${response.quantity} quantity.`).show()
              $('.js-qty__adjust--plus').css("pointer-events","none");
            }
          }
          else{
            if(response.quantity <$('input.dis-product-qty').val()){
              $('input.dis-product-qty').val(response.quantity);
              $("span.qty-note").empty().append(`You can not enter more than ${response.quantity} quantity.`).show()
              $('.js-qty__adjust--plus').css("pointer-events","none");
            }
            //  $('input.js-qty__num').val(response.quantity);
            // $(".product-delivary span.note.massage_wipwe").append(`only ${response.quantity} quntttey avalable`).show();
          }
           
          $(".product-delivary span.note.massage_wipwe").removeClass('hide').removeClass('error').addClass('success').empty();
          $(".product-delivery-form ").removeClass('error').addClass('success');
          $(".product-delivary span.note.massage_wipwe").append(response.message).show();
          $(".btn.btn--full.add-to-cart-wrapper").removeClass('disable').hide();
          $('.btn.btn--full.add-to-cart').removeAttr("disabled");
          $('.product-block.product_quantity.small--hide').show();
          $('.product-block.product-buy-button.small--hide').removeClass("hide-qty");
          // $(".btn.btn--full.add-to-cart").click();
          $('button.add-to-cart, button.js-qty__adjust').attr("data-max_qty",response.quantity);
        }
        // $('#check_zipcode, #check_zipcode_mobile').text("Change");
        $('#check_zipcode, #check_zipcode_mobile').hide();
        $('#check_zipcode_cleare_mobile, #check_zipcode_cleare').show();
      },
      error: function(xhr, status, error) {
        console.log('Failed to retrieve cart data:', error);
      }
    });
  }

  // click to check qty_check

  $(document).on('click', '#cart_delivery-location-search', function(event) {
    event.preventDefault();
    var zipcode = $('#cart_delivery_location_zip').val();
    console.log("zipcode");
    if(zipcode.length <= 5){
      $('.cart-zip-massage-main').show();
      $('.msg-status').text('please enter valid zip').show().css("color", "red");
      console.log("zipcode");
    }else{
      console.log(zipcode);
      post_zipApp_cart(zipcode,cart_pro);
    }  
  });


  var shping_title = "";
  let post_zipApp_cart = (zipcode, cart_pro) => {

  console.log("cart products",cart_pro, zipcode);
  // console.log(post_api);
  $.ajax({
    url: post_api,
    type: 'POST',
    data:{
      "zipcode": zipcode,
      "product_ids": cart_pro
    },
    success: function(response) {
      // var response = JSON.parse(response); 
      console.log(typeof response);
      console.log("Response",response);
      if(typeof response === "string"){
        var response = JSON.parse(response); 
      }
      $('#cart-max_dyas-date-input, #date-picker-input').val('');
      $('.cart_item_wrapper .error_massages').hide();
      console.log(response);
      // console.log(response.success);
      localStorage.removeItem("Zipcode");
      localStorage.setItem("Zipcode", zipcode );
      if(response.success != true)
      {
        $(".date-pick-btn").addClass("invalid");
        $('#cart-checkbox-btn-overlay').show();
        $('.cart-zip-massage-main').show();
        $('.cart-zip-massage-main .msg-status').text(`${response.error.message}`).css("color", "red");
        console.log( $('#CartPageForm .cart__item[data-product-id='+response.error.variant_ids+']').length);
        $('#CartPageForm .cart__item[data-product-id='+response.error.variant_ids+']').find('.cart__item-details .cart__item-title .error_massages').empty();
        $('#CartPageForm .cart__item[data-product-id='+response.error.variant_ids+']').find('.cart__item-details .cart__item-title .error_massages').append(response.error.message).show().css("color", "red");

        $('.cart__item-details .cart__item-title').text();
        var check_var_id = response.error.variant_ids.split(',');
        console.log(check_var_id.length)
        jQuery.each( check_var_id, function( i, val ) {
          $('#CartPageForm .cart__item[data-product-id='+response.error.variant_ids[i]+']').find('.cart__item-details .cart__item-title .error_massages').text(`${response.error.message}`).css("color", "red");
        });
      }else{
        // if ($('.order-slots-date').length > 0){
        //   $('.order-slots-date').empty();
        //      jQuery.each( response.dates, function( i, val ) {
        //        if(i == 0){
        //          $('.order-slots-date').append(`<option value="" disabled="disabled" selected="selected">Select date</option>`);
        //        }
        //        $('.order-slots-date').append(`<option value="${response.dates[i]}">${response.dates[i]}</option>`);
        //       });
      }

      let cart_pro_properrtes = [];
        
      jQuery.each(response.products, function( i, val ) {
        // console.log(i);
        // console.log($(".js-qty__wrapper .js-qty__num[data-id_js_used='"+i+"']").val());
        // console.log($(".js-qty__wrapper[data-pro-cart-id='"+i+"']").find('.js-qty__adjust').length);
        if(val < $(".js-qty__wrapper .js-qty__num[data-id_js_used='"+i+"']").val()){
          $(".js-qty__wrapper .js-qty__num[data-id_js_used='"+i+"']").val(val);
          $('#CartPageForm .cart__item[data-product-id='+i+']').find('.cart__item-details .cart__item-title .error_massages').text(`You can not enter more than ${val} quantity.`).css("color", "red").show();
          $('#CartPageForm .cart__item[data-product-id='+i+']').find('.js-qty__adjust--plus').css("pointer-events","none");
        }
          $(".date-pick-btn").removeClass("invalid");
          console.log("Value..........",val);
          $(".js-qty__wrapper[data-pro-cart-id='"+i+"']").attr('data-max_qty', val);
             
          setTimeout(function() {
            var line_id_pro =  $(".js-qty__wrapper[data-pro-cart-id='"+i+"']").attr('data-js_line_items');
            cart_pro_properrtes.push(`{'line':${line_id_pro},'properties'{'_max-qty':${val}}}`);
            fetch("/cart/change.json", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify(
                {
                  line: line_id_pro,
                  properties: {"_max-qty":val}
                }
              )
            });
          }, 1500);
        });
        // console.log(cart_pro_properrtes);
        // cartitemspropertesupdate(cart_pro_properrtes);
        cartattupdate(response.title);
           
        $('.cart-zip-massage-main').show();
        $('.cart-zip-massage-main .msg-status').text(`Please select date`).css("color", "green");
        $('#cart-max_dyas-date-input').val(response.max_days);
        if ($('.product-delivery-form.deliery-date-picker').length > 0){
          $('.product-delivery-form.deliery-date-picker #cart-date-picker').empty();
          jQuery.each( response.dates, function( i, val ) {
            $('.product-delivery-form.deliery-date-picker #cart-date-picker').append(`<li data-select-date="${response.dates[i]}">${response.dates[i]}</li>`);
          });
        }
        //  }
        // $('#cart_delivery-location-search').hide();
        // $('.change_cleare_zip').show();
      },
      error: function(xhr, status, error) {
        console.log('Failed to retrieve cart data:', error);
      }
    });
  }
  $(document).on('click','.date-pick-btn.invalid',function(){
    $(".check_pdp_zip").addClass("focus");
  });


  let cartattupdate = (cart_attrt) => {
    var headers = new Headers({ 'Content-Type': 'application/json' });
  
      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({attributes: { 'shopping_title': cart_attrt} })
      };
      fetch('/cart/update.js', request)
      .then(function() {
        // location.href = '/cart';
        console.log("success:-attr");
      });
  };
  // console.log(shping_title);
  // select date in cart page 

  $(document).on('click', '#cart-date-picker>li', function(event) {
    // console.log("test");
    $('#cart-date-picker>li').removeClass('active');
    $(this).addClass('active');
    $('#date-picker-input').val($(this).attr('data-select-date'));
    if($('#date-picker-input').val() != null && $('#cart_delivery_location_zip')){
      $('#cart-checkbox-btn-overlay').hide();
    }
    $('#cart-date-picker').hide();
    $('.cart-zip-massage-main').hide();
     var formData = {
      attributes: {
        'Order_Due_Date': $('#date-picker-input').val(),
        'Order_Location_Zip':$('#cart_delivery_location_zip').val(),
        'Order_Dispatch_Day':$('#cart-max_dyas-date-input').val(),
      }
    };
  console.log(formData);

  var headers = new Headers({ 'Content-Type': 'application/json' });

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(formData)
  };
    
  fetch('/cart/update.js', request)
    .then(function() {
      // location.href = '/cart';
    });
  });

  $("#delivery_dates").change(function(){
      console.log($(this).val());
      var formData = {
        attributes: {
          'Order_Due_Date': $(this).val(),
          'Order_Location_Zip':$('#delivery_location_zip').val(),
          'Order_Dispatch_Day':order_dispatch_day,
        }
      };
  });


  $("input.cart-remove-items-selector").on('change', function(event) {
    check_remove_items($(this).val());
  });


  $("input#cart-item-select").on('change', function(event) {
    if($(this).is(":checked")) {
      $( "input.cart-remove-items-selector" ).prop('checked', true);
      $('.selected_items-remove').hide();
      $('.all_product_remove').show();
     $('span.cart-page-itens-count').text($(this).val());
   }else{
      $( "input.cart-remove-items-selector" ).prop('checked', false);
      $('.selected_items-remove').show();
      $('.all_product_remove').hide();
     $('span.cart-page-itens-count').text(0);
   }
  });

  var products_check = [];
  var products = {};
  let check_remove_items = (value_main) => {
  $( "input.cart-remove-items-selector" ).each(function( index ) {
    if (index == 0){
       products_check = [];
      products = {};
    }
    if($(this).is(":checked")) {
      // let product = {};
      // product.id = $(this).val();
      // product.quantity = 0;
      // products.push(product);
      products[$(this).val()] = 0;
      products_check.push($(this).val()+":"+0);
    }
  });

  // console.log($( "input.cart-remove-items-selector" ).length == products.length);
  // console.log(products_check.length);
  $('span.cart-page-itens-count').text(products_check.length);
    if($( "input.cart-remove-items-selector" ).length == products_check.length){
       // $( "input.cart-remove-items-selector" ).prop('checked', true);
        $( "input#cart-item-select" ).prop('checked', true);
        $('.selected_items-remove').hide();
        $('.all_product_remove').show();
    }else{
       $( "input#cart-item-select" ).prop('checked', false);
       $('.selected_items-remove').show();
        $('.all_product_remove').hide();
    }
  };

  $(".selected_items-remove").on('click', function(event) {
    // console.log(products);
    const ADDTOCART_OBJECT = { updates: products };
    // console.log(ADDTOCART_OBJECT);
    // console.log(JSON.stringify(ADDTOCART_OBJECT));
     $.ajax({
       type: 'POST',
       url: '/cart/update.js',
       data: ADDTOCART_OBJECT,
       dataType: 'json',
      success:function(deletesuccess){
        console.log(deletesuccess);
           setTimeout(function() {
             location.reload();
           },100);
          },
        error: function(xhr, status, error) {
          console.log('Failed to retrieve cart data:', error);
        } 
  
     });
  });



// cart page gift check code START


$(document).ready(function() {
if (cart_gitf_attr){
  $('#cart_gift_check').prop('checked', true);
}else{
  $('#cart_gift_check').prop('checked', false);
}
});

// cart page gift check code END